import { render, staticRenderFns } from "./ShareOnSocialMedias.vue?vue&type=template&id=6fbc2946&scoped=true&"
import script from "./ShareOnSocialMedias.vue?vue&type=script&lang=js&"
export * from "./ShareOnSocialMedias.vue?vue&type=script&lang=js&"
import style0 from "./ShareOnSocialMedias.vue?vue&type=style&index=0&id=6fbc2946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbc2946",
  null
  
)

/* custom blocks */
import block0 from "./ShareOnSocialMedias.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports